export default __webpack_public_path__ + "static/media/5-years-logo-white.4b5517c7.png";